<div class="login-screen">
  <app-festive-fireworks [contained]="true" [duration]="4500" [fountains]="[0.1, 0.9]"></app-festive-fireworks>
  <main class="login-card" aria-labelledby="loginTitle">
    <div class="login-brand">
      <span class="logo-crop"><img src="./assets/Elixir_Retail.svg" alt="Elixir Retail" /></span>
      <app-festive-doodle size="lg"></app-festive-doodle>
    </div>

    <!-- Sign in -->
    <ng-container *ngIf="!showResetForm">
      <header class="login-head">
        <h1 id="loginTitle">Sign in</h1>
        <p>Use your billing counter account.</p>
      </header>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="field">
          <label for="username">Username</label>
          <input
            type="text"
            id="username"
            formControlName="username"
            class="field__input"
            placeholder="e.g. counter1"
            autocomplete="username"
            autocapitalize="off"
            spellcheck="false"
            [class.is-invalid]="submitted && f['username'].errors"
            [attr.aria-invalid]="submitted && !!f['username'].errors"
            aria-describedby="usernameError"
          />
          <p id="usernameError" class="field__error" *ngIf="submitted && f['username'].errors?.['required']">
            Enter your username
          </p>
        </div>

        <div class="field">
          <label for="password">Password</label>
          <div class="field__control">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              class="field__input"
              placeholder="Your password"
              autocomplete="current-password"
              [class.is-invalid]="submitted && f['password'].errors"
              [attr.aria-invalid]="submitted && !!f['password'].errors"
              aria-describedby="passwordError"
            />
            <button
              type="button"
              class="field__toggle"
              (click)="togglePassword()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              [title]="showPassword ? 'Hide password' : 'Show password'"
            >
              <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'" aria-hidden="true"></i>
            </button>
          </div>
          <p id="passwordError" class="field__error" *ngIf="submitted && f['password'].errors?.['required']">
            Enter your password
          </p>
        </div>

        <div *ngIf="error" class="login-alert" role="alert">
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
          <span>{{ error }}</span>
        </div>

        <button type="submit" [disabled]="loading" class="login-submit btn-creative-submit">
          <i *ngIf="loading" class="pi pi-spin pi-spinner" aria-hidden="true"></i>
          {{ loading ? "Signing in…" : "Sign in" }}
        </button>

        <button *ngIf="showResetLink" type="button" class="login-link" (click)="openResetForm()">
          Forgot password?
        </button>
      </form>
    </ng-container>

    <!-- Password reset -->
    <ng-container *ngIf="showResetForm">
      <header class="login-head">
        <h1 id="loginTitle">Reset password</h1>
        <p>
          {{ otpSent ? "Choose a new password for " : "Enter the OTP sent for " }}<strong>{{ loginForm.value.username }}</strong>.
        </p>
      </header>

      <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" novalidate>
        <div class="field" *ngIf="!otpSent">
          <label for="otp">One-time password</label>
          <input
            type="text"
            id="otp"
            formControlName="otp"
            class="field__input field__input--otp"
            placeholder="6-digit code"
            inputmode="numeric"
            autocomplete="one-time-code"
          />
        </div>

        <ng-container *ngIf="otpSent">
          <div class="field">
            <label for="newPassword">New password</label>
            <input
              type="password"
              id="newPassword"
              formControlName="newPassword"
              class="field__input"
              placeholder="New password"
              autocomplete="new-password"
            />
          </div>
          <div class="field">
            <label for="confirmPassword">Confirm password</label>
            <input
              type="password"
              id="confirmPassword"
              formControlName="confirmPassword"
              class="field__input"
              placeholder="Repeat new password"
              autocomplete="new-password"
            />
          </div>
        </ng-container>

        <div *ngIf="reseterror" class="login-alert" role="alert">
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
          <span>{{ reseterror }}</span>
        </div>

        <button type="submit" class="login-submit">
          {{ otpSent ? "Update password" : "Verify OTP" }}
        </button>

        <button type="button" class="login-link" (click)="backToSignIn()">
          <i class="pi pi-arrow-left" aria-hidden="true"></i> Back to sign in
        </button>
      </form>
    </ng-container>
  </main>

  <p class="login-foot">Elixir POS · Front office</p>
</div>
